import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=098d114c&scoped=true&lang=pug&"
import script from "./StatisticsView.vue?vue&type=script&lang=js&"
export * from "./StatisticsView.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=098d114c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d114c",
  null
  
)

export default component.exports